import './dropdown.scss';

import React, { useEffect, useRef, useState } from 'react';

import downArrowIcon from '@progymedia/sbi-web-englander/src/images/englander-icons/Down-Short-Arrow-Icon.svg';

interface IElements {
    label: string;
    value: string;
}

interface IProps {
    title: string;
    iconLeft?: string;
    elements: IElements[];
    setCurrentValue: React.Dispatch<React.SetStateAction<string | undefined>>;
    className?: string;
}

export default function Dropdown(props: IProps) {
    const { title, iconLeft, elements, setCurrentValue, className } = props;
    const [showElements, setShowElements] = useState(false);
    const [currentLabel, setCurrentLabel] = useState(title);
    const componentRef = useRef();

    useEffect(() => {
        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
        function handleClick(e: any) {
            if (componentRef && componentRef.current) {
                const ref: any = componentRef.current;
                if (!ref.contains(e.target)) {
                    setShowElements(false);
                }
            }
        }
    }, []);
    return (
        <div
            className={`dropdown-container ${className ? className : ''}`}
            onClick={() => setShowElements(!showElements)}
            onBlur={() => setShowElements(false)}
            ref={componentRef as any}
        >
            {iconLeft && (
                <img
                    className='dropdown-icon-left'
                    src={iconLeft}
                    alt=''
                ></img>
            )}
            <span className='dropdown-title'>{currentLabel}</span>
            <img className='dropdown-arrow-down' src={downArrowIcon} alt='' />
            {showElements && (
                <div
                    className='dropdown-elements'
                    onClick={(e) => e.stopPropagation()}
                >
                    {elements.map((e, index) => {
                        return (
                            <div
                                key={`${title}-dropdown-elem-${index}`}
                                onClick={() => {
                                    setCurrentValue(e.value);
                                    setCurrentLabel(e.label);
                                    setShowElements(false);
                                }}
                            >
                                {e.label}{' '}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
